/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_History_Verb_Task_Updated_GroupInputs */

const en_case_history_verb_task_updated_group = /** @type {(inputs: Case_History_Verb_Task_Updated_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`updated ${i?.count} times`)
};

const pt_br2_case_history_verb_task_updated_group = /** @type {(inputs: Case_History_Verb_Task_Updated_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`atualizada ${i?.count} vezes`)
};

/**
* | output |
* | --- |
* | "updated {count} times" |
*
* @param {Case_History_Verb_Task_Updated_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_updated_group = /** @type {((inputs: Case_History_Verb_Task_Updated_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_Updated_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_updated_group(inputs)
	return pt_br2_case_history_verb_task_updated_group(inputs)
});